const postsStrings = {
  postsHeader: {
    addPostBtn: 'Add Post',
  },

  postsFilter: {
    searchBarPlaceholder: 'Post ID',
  },

  postsList: {
    postsGridNoResultsFound: 'No results matching your search criteria',
    postsGridHeader: {
      postsIdGridHeader: 'ID',
      postsTextGridHeader: 'Text',
      postsMediaGridHeader: 'Media',
      postsLabelsGridHeader: 'Labels',
      postsDateGridHeader: 'Date',
      postsLikesGridHeader: 'Likes',
      postsCommentsGridHeader: 'Comments',
    },
    copiedToClipboardText: 'Copied to clipboard 🚀',
    deleteActionPopupTitle: 'Are you sure you want to delete this post',
    deleteActionPopupYesBtn: 'Yes',
    deleteActionPopupNoBtn: 'No',
  },

  addPost: {
    formTitle: 'Post Details',
    formTextFieldLabel: 'Text',
    formTopicFieldLabel: 'Topics',
    formTopicFieldPlaceholder: 'Add Topic(s)',
    formMediaFieldLabel: 'Media',
    formMediaFieldBtnText: 'Attach Files',
    formContentValidationErrorText:
      'You have to add at least one content type (text or multi-media)',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    requestErrorMessage: 'Error happened, please try again',
    formAddBtnText: 'Add',
    formEditBtnText: 'Edit',
  },

  rssFeedHeader: {
    addRssFeedBtn: 'Add Rss Feed',
  },

  rssFeedFilter: {
    searchBarPlaceholder: 'Channel Link',
  },

  rssFeedList: {
    rssFeedGridNoResultsFound: 'No results matching your search criteria',
    rssFeedGridHeader: {
      rssFeedIdGridHeader: 'ID',
      rssFeedLinkGridHeader: 'Channel Link',
      rssFeedForceOpenGraphGridHeader: 'Force OG',
      rssFeedLastPullDateGridHeader: 'Last Pull Date',
      rssFeedPlaceholderImageGridHeader: 'Image',
      rssFeedTagsGridHeader: 'Interests',
      rssFeedActionsGridHeader: 'Actions',
    },
    enableBtnText: 'Enable',
    disableBtnText: 'Disable',
    forceOpenGraphBtnText: 'Force OG',
    disableOpenGraphBtnText: 'Disable OG',
    imageFileText: 'Image',
    copiedToClipboardText: 'Copied to clipboard 🚀',
    forceOpenGraphtrueActionPopupTitle:
      'Are you sure you want to Force Open Graph for this channel?',
    forceOpenGraphfalseActionPopupTitle:
      'Are you sure you want to Disable Open Graph for this channel?',
    disabletrueActionPopupTitle: 'Are you sure you want to Disable this channel?',
    disablefalseActionPopupTitle: 'Are you sure you want to Enable this channel?',
    rssFeedListActionsPopupYesBtn: 'Yes',
    rssFeedListActionsPopupNoBtn: 'No',
  },

  addRssFeed: {
    formTitle: 'Rss Feed Details',
    formLinkFieldLabel: 'Rss Feed Link',
    formFrequencyFieldLabel: 'Update Frequency (hours)',
    formTopicFieldLabel: 'Topics',
    formTopicFieldPlaceholder: 'Add Topic(s)',
    formReadImageFieldLabel: 'Read Image',
    formReadImageFieldText: 'Should read image from feed?',
    formForceOpenGraphFieldLabel: 'Force OG',
    formForceOpenGraphFieldText: 'Should force open graph data?',
    formMediaFieldLabel: 'Media',
    formMediaFieldBtnText: 'Attach Files',
    formContentValidationErrorText:
      'You have to add at least one content type (text or multi-media)',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    requestErrorMessage: 'Error happened, please try again',
    formAddBtnText: 'Add',
  },
};

export default postsStrings;
